import Modal from "react-modal";
import React, { useContext, useEffect } from "react";
import firstLogo from "../../images/Group18.png";
import secondLogo from "../../images/VectorSmartObject.png";
import { ScoreContext } from "../../Context/ScoreContext";
import coin from "../../images/coin.svg";
import "../WinModal/WinModal.css";
import { Link, useNavigate } from "react-router-dom";
import { LevelContext } from "../../Context/LevelContext";
import UserNameContext from "../../Context/UserNameContext.js";
import axios from "axios";
import Footer from "../Footer/Footer";
// import backgroundVideo from "../../videos/golden-particles.mov";

export const WinThemeOne = ({ show, onClose, restartGame, currentLevel }) => {
  const { score, totalScore, setScore } = useContext(ScoreContext);
  const { userName, setUserName } = useContext(UserNameContext);
  const { completeLevel } = useContext(LevelContext);

  const navigate = useNavigate();

  useEffect(() => {
    const storedName = localStorage.getItem("userName");
    if (storedName) setUserName(storedName);

  },[])

  const postVisitorScore = () => {
    axios
      .post("https://findzok.com/api/visitors", {
        id: localStorage.getItem("userId"),
        name: localStorage.getItem("userName"),
        score: score,
      })
      .then((response) => {

        localStorage.setItem("userId", response.data.data.id);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleReturn = () => {
    postVisitorScore();
    localStorage.setItem("score", 0);
    setScore(0);
  };

  const handleNextLevel = () => {
    completeLevel(currentLevel + 1);
    localStorage.setItem("score", totalScore);
    navigate(`/theme-${currentLevel + 1}`); // Adjust the route according to your setup
    postVisitorScore();
    onClose();
  };

  return (
    <>
      <Modal className="winModalBox" isOpen={show} onRequestClose={onClose}>
        <div className="container-fluid">
          <div className="flex-grow flex flex-col lg:justify-center items-center">
            <div className="winModalCotainer pt-4">
              <div className="winContent h-screen w-screen overflow-auto flex flex-col lg:justify-center items-center">
                <div className="flex-grow flex justify-center items-center flex-col">
                  <h2 className="mb-3 px-4 pt-4 lg:px-0 lg:pt-0">Great work Dr. {userName}, You've located all the Betaloc Zok boxes. </h2>
                  <h3>Your score is {score}/200</h3>
                
                  <h2  className="p-3"> Prepare for the <span style={{color: "#ffc402"}}>Next level!</span></h2>

                  <div className="d-flex justify-content-center align-items-center mt-4 flex-wrap ">
                    <button onClick={restartGame} className=" playButton">
                      Play Again
                    </button>
                    {currentLevel === 2 && (
                      <div>
                        <Link to="/choose-theme">
                          <button
                            onClick={handleReturn}
                            className="playButton "
                          >
                            Return Home{" "}
                          </button>
                        </Link>
                      </div>
                    )}
                    {currentLevel < 2 && (
                      <div>
                        <Link to="/choose-theme">
                          <button className="playButton">Return Home </button>
                        </Link>
                        <button
                          onClick={handleNextLevel}
                          className="nextButton"
                        >
                          Play Theme 2
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <Footer />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
